import React, { useState, useEffect } from 'react';
import { map } from 'lodash';
import { useRecoilState } from 'recoil';
import { quizListFilterState } from 'modules/learning/recoilState';
import { CMAIN_THEMES } from 'constants/learningboard.const';
import { Checkbox, Form, Typography, Col, Row, Modal, Button } from 'antd';
import { RedoOutlined } from '@ant-design/icons';
import { FormWrapper } from 'GlobalStyles';

const QuizListFilterModal = ({ modalState, setModalState }: any) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [quizFilter, setQuizFilter] = useRecoilState(quizListFilterState);
  const { Title } = Typography;

  useEffect(() => {
    let value = {
      subject: quizFilter.subject,
      quiz_types: quizFilter.quiz_types,
      is_full_drill: quizFilter.is_full_drill,
      tagNames: quizFilter.tagNames,
      count: quizFilter.subject.length + quizFilter.quiz_types.length + quizFilter.is_full_drill.length,
    };
    form.setFieldsValue(value);
  }, []);

  function handleCancel() {
    setModalState({ visible: false });
  }

  function onClickSubmit() {
    setModalState({ visible: false });

    const value = {
      subject: '',
      quiz_types: '',
      is_full_drill: '',
      tagNames: [] as any[],
      count: 0,
    };

    const subject = form.getFieldValue('subject');
    if (subject) {
      value.subject = subject.join('+');
      map(subject, (v: string) => {
        value.tagNames.push(v);
      });
      value.count = 1;
    }

    const quiz_types = form.getFieldValue('quiz_types');
    if (quiz_types) {
      value.quiz_types = quiz_types.join('+');
      map(quiz_types, (v: string) => {
        value.tagNames.push(v);
      });
      value.count = 1;
    }

    const is_full_drill = form.getFieldValue('is_full_drill');
    if (is_full_drill) {
      value.is_full_drill = is_full_drill;
      map(is_full_drill, (v: boolean) => {
        value.tagNames.push('full_drill');
      });
      value.count = 1;
    }

    setQuizFilter({
      subject,
      quiz_types,
      is_full_drill,
      tagNames: value.tagNames,
      count: value.count,
    });

    modalState.onFinish && modalState.onFinish(value);
  }

  useEffect(() => {
    setVisible(modalState.visible);
  }, [modalState.visible]);

  return (
    <Modal
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      style={{ padding: '15px' }}
      footer={
        <Row gutter={[8, 8]} justify='space-between'>
          <Col>
            <Button
              onClick={() => {
                let value = {
                  subject: [],
                  quiz_types: [],
                  is_full_drill: [],
                  tagNames: [],
                  count: 0,
                };

                form.setFieldsValue(value);
              }}
            >
              <RedoOutlined />
              초기화
            </Button>
          </Col>
          <Col>
            <Button onClick={handleCancel}>닫기</Button>
            <Button type='primary' onClick={onClickSubmit}>
              적용
            </Button>
          </Col>
        </Row>
      }
      width={540}
      onCancel={handleCancel}
    >
      <Title level={3}>필터</Title>
      <FormWrapper style={{ padding: '0px' }}>
        <Form form={form} colon={false} layout='vertical' className='form-normal'>
          <Form.Item name={'subject'} label='주제'>
            <Checkbox.Group className='checkbox-btn'>
              {CMAIN_THEMES.map(({ id, link, name }) => (
                <Checkbox key={id} value={link}>
                  {name}
                </Checkbox>
              ))}
            </Checkbox.Group>
          </Form.Item>

          <Form.Item name={'quiz_types'} label='단계'>
            <Checkbox.Group className='checkbox-btn'>
              <Row>
                <Checkbox value='clarification' style={{ height: '100%' }}>
                  Clarification
                </Checkbox>
                <Checkbox value='structuring' style={{ height: '100%' }}>
                  Structuring
                </Checkbox>
                <Checkbox value='analysis' style={{ height: '100%' }}>
                  Analysis
                </Checkbox>
                <Form.Item name={'is_full_drill'}>
                  <Checkbox.Group className='checkbox-btn'>
                    <Checkbox value={true}>세트문제</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </Row>
            </Checkbox.Group>
          </Form.Item>
        </Form>
      </FormWrapper>
    </Modal>
  );
};

QuizListFilterModal.defaultProps = {};

export default QuizListFilterModal;
